<template>
  <div>
    <div class="tabs" :class="isGroupOrder && 'group-order-tabs'">
      <ul>
        <li
          v-for="tab in tabs"
          :class="{ 'is-active': tab.isActive }"
          :key="tab.name"
        >
          <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    isGroupOrder: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    selectTab(selectedTab) {
      this.$emit('setActiveTab', selectedTab)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.tabs {
  margin: 2.5rem 0;
}

.tabs ul {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  list-style: none;
}

.tabs ul li {
  display: inline-block;
  margin: 0 auto;
  width: 100%;
  cursor: pointer;
  display: block;
  font-weight: 400;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;

  & a {
    display: block;
    text-decoration: none;
    font-size: 18px;
    font-family: $editorial;
    color: #514d43;

    &:hover {
      color: $onyx;
    }
  }
}

.tabs ul li.is-active {
  border-bottom: 2px solid $onyx;

  & a {
    color: #000000;
  }
}

@media screen and (max-width: 630px) and (min-width: 350px) {
  .group-order-tabs {
    margin: 0rem 0 0rem 0;
  }
}
</style>
